// extracted by mini-css-extract-plugin
export default {"page":"_1nRHgzonGOSWjRJhLCKw2p"};